/*
 * @Description:
 * @Author: ll
 * @Date: 2021-09-09 16:48:20
 * @LastEditTime: 2021-09-09 15:50:39
 * @LastEditors: ll
 */
import Request from '@/utils/request'
//获取案件详情
export function detailInfo(caseNo) {
  return Request.get(`/case/detail/${caseNo}`)
}

// 获取案件概况
export function overview(caseNo) {
  return Request.get(`/case/overview/${caseNo}`)
}

// 获取著作人详情
export function copyDetail(data) {
  return Request.post('/author/detail', data)
}

// 下载邮寄材料
export function downloadMaterials(data) {
  return Request.post('/wordHandle/partner/downloadMaterials', data)
}

// 下载接口
export function urlToFileDown(url) {
  return Request.get(`/upload/urlToFileDown?fileUrl=${url}`)
}

// 获取案件材料
export function attachments(caseNo) {
  return Request.get(`/case/attachments/${caseNo}`)
}
